import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, CalendarIcon, MapPinIcon, ClockIcon, UsersIcon, SparklesIcon, ArrowUpRightIcon } from 'lucide-react';
const FLYER_IMAGE = 'https://cdn.magicpatterns.com/uploads/oHes5dNrpHAe14qkJrZLSk/Voices_of_Impact_NY.png';
const REGISTRATION_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSfTMee8D7heBnot8-q26aDKJ7WP-W1JsiuVJHs-y8ZqIn8fwg/viewform';
const DETAILS = [{
  icon: CalendarIcon,
  label: 'Date',
  value: 'Thursday, October 1'
}, {
  icon: ClockIcon,
  label: 'Time',
  value: '5:00 PM – 8:00 PM'
}, {
  icon: MapPinIcon,
  label: 'Location',
  value: '30 Rockefeller Plaza, New York, NY'
}, {
  icon: UsersIcon,
  label: 'Attendance',
  value: '100 invited guests'
}];
const CONSIDERATION = [{
  title: 'Leadership of consequence',
  text: 'Executives, founders, public servants, and institutional leaders whose decisions shape organizations, industries, and communities.'
}, {
  title: 'Thought leadership',
  text: 'Journalists, academics, creatives, and subject-matter authorities whose perspectives inform the national conversation.'
}, {
  title: 'Service and stewardship',
  text: 'Individuals with a demonstrated record of mentorship, philanthropy, and investment in the advancement of others.'
}];
export function VoicesOfImpactNYPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-[#0b1f3f] text-white font-nunito" data-id="element-3665" data-mp="dkvemg6gli3w">
      {/* Header */}
      <header className="relative z-10 w-full px-6 py-6 sm:px-12 flex items-center justify-between border-b border-[#c9a227]/30" data-id="element-3666" data-mp="3v1wmsu8sww62">
        <a href="#" className="flex items-center gap-3 group" aria-label="Honduran American Association — Home" data-id="element-3667" data-mp="3u0v3jklkwm5">
          <img src="https://cdn.magicpatterns.com/uploads/b1GB8Z9aEvoE58p9BdX4qx/HonduranAmericanLogoNew.png" alt="Honduran American Association" className="h-10 w-auto object-contain brightness-0 invert group-hover:opacity-80 transition-opacity" data-id="element-3668" data-mp="wbmnzhqg58ia" />
        </a>
        <a href="#" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-sm font-semibold transition-colors" data-id="element-3669" data-mp="w95mpr67pneo">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-3670" data-mp="n995ubq2dsu6" />
          Back to site
        </a>
      </header>

      <main data-id="element-3671" data-mp="ihiqfrc9sevw">
        {/* Invitation */}
        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-14 lg:py-20" data-id="element-3672" data-mp="igg1hoyicmim">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-3673" data-mp="djpiotvbjcti">
            {/* Flyer */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.94,
            y: 20
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            ease: [0.16, 1, 0.3, 1]
          }} className="order-2 lg:order-1 flex justify-center" data-id="element-3674" data-mp="8lfreucpswd6">
              <a href={FLYER_IMAGE} target="_blank" rel="noopener noreferrer" className="relative block w-full max-w-md rounded-2xl overflow-hidden shadow-2xl ring-1 ring-[#c9a227]/50 bg-white group" aria-label="View the full invitation" data-id="element-3675" data-mp="2k6oocpm2zuzu">
                <img src={FLYER_IMAGE} alt="Voices of Impact — A Hispanic Heritage Month Celebration, October 1, 30 Rockefeller Plaza, New York" className="w-full h-auto block transition-transform duration-500 group-hover:scale-[1.02]" data-id="element-3676" data-mp="1wi5cy17qj23j" />
              </a>
            </motion.div>

            {/* Copy */}
            <motion.div initial={{
            opacity: 0,
            x: 24
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1,
            ease: [0.16, 1, 0.3, 1]
          }} className="order-1 lg:order-2" data-id="element-3677" data-mp="1dqcnggrvjz0k">
              <p className="font-nunito text-[#c9a227] text-xs sm:text-sm font-bold uppercase tracking-[0.25em] mb-5" data-id="element-3678" data-mp="3kelafq19taqu">
                By Invitation · New York City
              </p>
              <p className="font-nunito text-white/70 text-base leading-relaxed mb-4" data-id="element-3679" data-mp="3u5zf0c82x0qu">
                The Board of Directors of the Honduran-American Association
                cordially invites you to
              </p>
              <h1 className="font-bebas text-5xl sm:text-6xl lg:text-7xl tracking-[0.08em] leading-[0.95] mb-3" data-id="element-3680" data-mp="7yhobzn27avg">
                Voices of Impact
              </h1>
              <p className="font-nunito text-white/80 text-sm sm:text-base uppercase tracking-[0.2em] mb-8" data-id="element-3681" data-mp="29pupcdlwoym8">
                A Hispanic Heritage Month Celebration
              </p>

              <div className="w-20 h-px bg-[#c9a227] mb-8" data-id="element-3682" data-mp="23mzu5rr7d036" />

              <div className="space-y-5 font-nunito text-white/80 text-base sm:text-lg leading-relaxed" data-id="element-3683" data-mp="23m804ld97af0">
                <p data-id="element-3684" data-mp="1pvcqv7yueraw">
                  Join a distinguished gathering of 100 leaders and influential
                  voices from across the country for an exceptional evening
                  celebrating leadership, service, and collective impact.
                </p>
                <p data-id="element-3685" data-mp="1kxb5uhhuwhws">
                  Connect with purpose, exchange inspiring perspectives, and
                  help shape a stronger, more connected future for the
                  communities we serve and lead.
                </p>
              </div>

              <div className="mt-10 flex flex-col sm:flex-row gap-3" data-id="element-3686" data-mp="31artar9tmbde">
                <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-[#c9a227] text-[#0b1f3f] font-bold text-sm uppercase tracking-wider hover:bg-[#dcb63b] transition-colors shadow-lg" data-id="element-3687" data-mp="318ow9na93hz6">
                  Request Your Invitation
                  <ArrowUpRightIcon className="w-4 h-4" data-id="element-3688" data-mp="2pverudx0d4lc" />
                </a>
                <a href={FLYER_IMAGE} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-white/25 text-white font-bold text-sm uppercase tracking-wider hover:bg-white/10 transition-colors" data-id="element-3689" data-mp="2px9hg5j85kvr">
                  View Invitation
                </a>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Details */}
        <section className="border-y border-white/10 bg-white/[0.03]" data-id="element-3690" data-mp="a63lfk1tiur7">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12" data-id="element-3691" data-mp="5c96sv12l5yz">
            <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-3692" data-mp="cprvh1r8sj30">
              {DETAILS.map(item => {
              const Icon = item.icon;
              return <div key={item.label} className="flex items-start gap-4" data-id="element-3693" data-mp="mmmsfg7vabf6">
                    <span className="flex-shrink-0 w-11 h-11 rounded-full border border-[#c9a227]/50 flex items-center justify-center" data-id="element-3694" data-mp="rlpssncwjtgt">
                      <Icon className="w-5 h-5 text-[#c9a227]" data-id="element-3695" data-mp="vmt6p4be3ffe" />
                    </span>
                    <div data-id="element-3696" data-mp="10lma23wypq1u">
                      <dt className="font-nunito text-white/50 text-xs font-bold uppercase tracking-[0.18em] mb-1" data-id="element-3697" data-mp="10kuprp8tfeqv">
                        {item.label}
                      </dt>
                      <dd className="font-nunito text-white font-semibold leading-snug" data-id="element-3698" data-mp="1ab5u3cwevpya">
                        {item.value}
                      </dd>
                    </div>
                  </div>;
            })}
            </dl>
          </div>
        </section>

        {/* Selection / consideration */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-20" data-id="element-3699" data-mp="24q6tbc11qpyc">
          <div className="max-w-3xl" data-id="element-3700" data-mp="20lz5dh2exe16">
            <p className="inline-flex items-center gap-2 font-nunito text-[#c9a227] text-xs font-bold uppercase tracking-[0.25em] mb-5" data-id="element-3701" data-mp="2em9xenfgkynx">
              <SparklesIcon className="w-4 h-4" data-id="element-3702" data-mp="29o8d5z6aqtav" />
              A Curated Gathering
            </p>
            <h2 className="font-bebas text-4xl sm:text-5xl tracking-wider leading-tight mb-5" data-id="element-3703" data-mp="1lynqp6axpdwu">
              An Invitation Extended with Intention
            </h2>
            <p className="font-nunito text-white/75 text-base sm:text-lg leading-relaxed" data-id="element-3704" data-mp="1vn5nzdk092vq">
              Attendance is limited to 100 guests. The Board of Directors is
              personally reviewing profiles of community leaders, thought
              leaders, and high-aptitude professionals to assemble a room where
              every voice contributes something meaningful. Submissions are
              considered on a rolling basis, and invitations are extended
              individually.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-12" data-id="element-3705" data-mp="3en56oys8e9im">
            {CONSIDERATION.map((item, i) => <motion.div key={item.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1,
            ease: [0.16, 1, 0.3, 1]
          }} className="rounded-2xl border border-white/10 bg-white/[0.04] p-7" data-id="element-3706" data-mp="30w02djdx4t1y" data-mpi={i}>
                <div className="w-10 h-px bg-[#c9a227] mb-5" data-id="element-3707" data-mp="288e1iiw2s2is" />
                <h3 className="font-bebas text-2xl tracking-wider mb-3" data-id="element-3708" data-mp="2d5vzxfcguzcj">
                  {item.title}
                </h3>
                <p className="font-nunito text-white/70 text-sm leading-relaxed" data-id="element-3709" data-mp="34esgp34fapcd">
                  {item.text}
                </p>
              </motion.div>)}
          </div>
        </section>

        {/* Registration CTA */}
        <section className="border-t border-[#c9a227]/30 bg-white/[0.03]" data-id="element-3710" data-mp="2zlfsgu3nokk5">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 lg:py-20 text-center" data-id="element-3711" data-mp="2zjml1cl7xwb3">
            <h2 className="font-bebas text-4xl sm:text-5xl tracking-wider leading-tight mb-4" data-id="element-3712" data-mp="2kqt6btdrtk7h">
              Register to Be Considered
            </h2>
            <p className="font-nunito text-white/75 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto mb-9" data-id="element-3713" data-mp="2bos56lff2e0j">
              Complete the registration form to share your background with the
              Board. Confirmed guests will receive their formal invitation and
              venue details by email ahead of October 1.
            </p>
            <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-9 py-4 rounded-full bg-[#c9a227] text-[#0b1f3f] font-bold text-sm uppercase tracking-wider hover:bg-[#dcb63b] transition-colors shadow-xl" data-id="element-3714" data-mp="etnpk2ld1fpd">
              Open Registration Form
              <ArrowUpRightIcon className="w-4 h-4" data-id="element-3715" data-mp="szz4dttasy3s" />
            </a>
          </div>
        </section>
      </main>

      <footer className="border-t border-white/10 py-8 text-center" data-id="element-3716" data-mp="17s9bap4t8273">
        <p className="font-nunito text-white/45 text-xs uppercase tracking-[0.2em]" data-id="element-3717" data-mp="12qac7rg3rrfy">
          Hosted by the Honduran-American Association
        </p>
      </footer>
    </div>;
}